import 'core-js/stable';
import { SILENT_REDIRECT_PATH } from '@/core/consts/oidc';
import { WHITELABEL_NAME } from '@/core/consts/wl';
import { TOKENS } from '@/core/styles/palettes';

declare const VERSION: string;

console.log('charter app: ', VERSION);

switch (WHITELABEL_NAME) {
  case 'mira':
    TOKENS.callToAction.brandPrimary = '#00aeef';
    TOKENS.callToAction.brandSecondary = '#00aeef';
    TOKENS.callToAction.hover.primary = '#1ac1ff';
    TOKENS.callToAction.hover.secondary = '#1ac1ff';

    TOKENS.callToAction.sunset.primary = TOKENS.callToAction.brandPrimary;
    TOKENS.callToAction.sunset.secondary = TOKENS.callToAction.brandPrimary;
    break;
  case 'hansjet':
    TOKENS.callToAction.brandPrimary = '#CB433C';
    TOKENS.callToAction.brandSecondary = '#CB433C';

    TOKENS.callToAction.sunset.primary = '#CB433C';
    TOKENS.callToAction.sunset.secondary = '#CB433C';
    break;
  case 'friends':
  case 'airmobility':
    break;
}

// The silent-renew iframe lands on a path the SPA fallback serves. Never boot the app there:
// it only has to hand the parent window its callback URL, and booting is what makes the
// renew time out (and can sign the user out). Top-level navigation to this path still gets
// the app, so a stray link is not a blank page.
if (window.parent !== window && window.location.pathname === SILENT_REDIRECT_PATH) {
  import('./silentCallback');
} else {
  import('./bootstrap');
}
